module.exports = "mutation UpdateStoreAccess($data:StoreAccessInput!){updateStoreAccess(data:$data){__typename success}}"